module.exports = __webpack_public_path__ + "img/icon_project07.51e6e2ba.png";